import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import SagaManager from 'helpers/SagaManager';

import history from './History';

/**
 * Initialize Redux Store.
 * @return {ReduxStore} Configured redux store
 */
export default function initStore(getReducers, appSagas) {
    const sagaMiddleware = createSagaMiddleware();
    const routerMiddlewareInstance = routerMiddleware(history);

    const middlewares =
        process.env.DEBUG_REDUX === 'true'
            ? applyMiddleware(routerMiddlewareInstance, sagaMiddleware, require('redux-logger')()) // eslint-disable-line global-require
            : applyMiddleware(routerMiddlewareInstance, sagaMiddleware);

    const store = createStore(
        // We need outerReducer to replace full state as soon as it loaded
        getReducers(),
        compose(
            middlewares,
            window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== 'production'
                ? window.__REDUX_DEVTOOLS_EXTENSION__()
                : (f) => f,
        ),
    );

    SagaManager.startSagas(sagaMiddleware, appSagas);

    // enable hot module reloading for reducers
    if (module.hot) {
        module.hot.accept(['reducers/estima'], () => {
            store.replaceReducer(getReducers());
        });

        module.hot.accept('helpers/SagaManager', () => {
            SagaManager.cancelSagas(store);
            // eslint-disable-next-line global-require
            require('helpers/SagaManager').default.startSagas(sagaMiddleware, appSagas);
        });
    }

    return store;
}
